import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var PeopleArrows = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 576 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M96 128a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0 176.08a44.11 44.11 0 0 1 13.64-32L181.77 204c1.65-1.55 3.77-2.31 5.61-3.57A63.91 63.91 0 0 0 128 160H64a64 64 0 0 0-64 64v96a32 32 0 0 0 32 32v128a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-96.39l-50.36-47.53a44.08 44.08 0 0 1-13.64-32zM480 128a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm32 32h-64a63.91 63.91 0 0 0-59.38 40.42c1.84 1.27 4 2 5.62 3.59l72.12 68.06a44.37 44.37 0 0 1 0 64L416 383.62V480a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32V352a32 32 0 0 0 32-32v-96a64 64 0 0 0-64-64zm-67.6 135.34-72.12-68.06A12 12 0 0 0 352 236v36H224v-36a12 12 0 0 0-20.28-8.73l-72.12 68.07a12.4 12.4 0 0 0 0 17.47l72.12 68.07a12 12 0 0 0 20.28-8.74V336h128v36.14a12 12 0 0 0 20.28 8.74l72.12-68.07a12.4 12.4 0 0 0 0-17.47z"
  }));
});
PeopleArrows.displayName = 'PeopleArrows';
export var PeopleArrowsDimensions = {
  height: 512,
  width: 576
};